import { render } from "./SectionFAQ.vue?vue&type=template&id=0cfb9ec8&scoped=true"
import script from "./SectionFAQ.vue?vue&type=script&lang=js"
export * from "./SectionFAQ.vue?vue&type=script&lang=js"

import "./SectionFAQ.vue?vue&type=style&index=0&id=0cfb9ec8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cfb9ec8"]])

export default __exports__